import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { renderRoutes } from 'scripts/helpers/Renderer'
import { routes } from 'scripts/routes'
import ErrorPrompt from 'scripts/components/errorLog/ErrorPrompt'

class SoompiEmbed extends Component {
  constructor(props) {
    super(props)
    const mountNode = document.getElementById('app')
    // Client side app config initialisation
    this.state = {
      appConfig: window[mountNode.dataset.appConfig],
      reload: false
    }
  }

  componentDidCatch(error, info) {
    if (error && info) {
      ErrorPrompt.notify(error, {
        message: error.toString(),
        context: info
      })
    }
  }

  render() {
    const { children } = this.props
    const relayedProps = { appConfig: this.state.appConfig, locale: this.props.locale }
    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, relayedProps)
    )
    return (
      <React.Fragment>
        {renderRoutes(routes, relayedProps)}
        {childrenWithProps}
      </React.Fragment>
    )
  }
}

export default withRouter(SoompiEmbed)



// WEBPACK FOOTER //
// ./assets/js/components/SoompiEmbed.jsx